import { COVERAGE_TABS } from '../../../../constants';
import { TRACKING_SUB_AREA } from '../../../../trackingV2';
import { createCoverageParamsSelector, createCoverageSelector } from '../../../common/coverage/selectors';
import * as filtersSelectors from '../../filters/selectors';

export const getDeviceCoverage = (store) => store.apps.analytics.vdc.coverage.device;

export const deviceCoverageSelector = createCoverageSelector({
  coverageStore: getDeviceCoverage,
  source: 'vdc',
  productSubArea: TRACKING_SUB_AREA[COVERAGE_TABS.devices.trackEvent],
});

export const getParams = createCoverageParamsSelector(
  filtersSelectors.getCoverageFiltersParams,
  getDeviceCoverage,
);
